<script setup>
const items = [
  'Требуется больше энергии для роста и&nbsp;развития',
  'Формируются <br/>мускулатура и&nbsp;скелет',
  'Развиваются <br/>мозг и&nbsp;зрение',
  'Формируется <br/>микрофлора кишечника'
]
</script>
<template>
  <div class="info-block" id="infoBlock">
    <div class="info-block__inner">
      <h2 class="info-block__title">в первые месяцы жизни щенка:</h2>
      <div class="info-block__wrap">
        <img src="@/assets/img/info-block-image.png" class="info-block__image" alt="" />
        <div class="info-block__items">
          <div class="info-block__item" v-for="(item, index) in items" :key="index">
            <img :src="require(`@/assets/img/info-icon${index + 1}.svg`)" alt="" />
            <p v-html="item"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>